import fill from "../../../common/apis/custom/web/getStorage";
export default fill;